import { UPDATE_APPLICANT_LICENSES } from '../../actionTypes';

export function updateApplicantLicenses(applicantId, licenses) {
  return {
    type: UPDATE_APPLICANT_LICENSES,
    applicantId,
    licenses
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/sync/licenses.js